import { SxProps, Typography } from '@mui/material';

import { StlPopup } from 'features/common/StlPopup/StlPopup';

// extra line in ERROR_MSG important for formatting
export const ERROR_MSG = (
  item: string,
) => `You do not have access to view this ${item}, as it is not available with your account.

Reach out to support for assistance.`;

const sx: SxProps = {
  fontSize: '0.875rem' /* body2 font size */,
  lineHeight: '1.5rem',
  whiteSpace: 'pre-line',
};

export default function NoAccessPopup({
  open,
  itemName,
  onClose,
}: {
  open: boolean;
  itemName: string;
  onClose: () => void;
}) {
  return (
    <StlPopup
      btnTxt="Close"
      cancel={false}
      title="Access Restricted"
      isOpen={open}
      onClose={onClose}
      onApply={onClose}
      sx={{ width: '300px' }}
    >
      <Typography sx={sx}>{ERROR_MSG(itemName)}</Typography>
    </StlPopup>
  );
}
